import i18n from "i18next";
import { DOCS_URL_FULL } from "src/app/config";
import { SETTINGS_GUIDE_3CX_ROUTE } from "src/app/router/config";
export const VoIpServerTypes = {
    '3CX': '3CX',
    FreePBX: 'FreePBX',
    FreeSwitch: 'FreeSwitch',
    Asterisk: 'Asterisk',
    Other: 'Other',
};
export const VoIpServerGuideRoutes = {
    '3CX': SETTINGS_GUIDE_3CX_ROUTE,
    FreePBX: `${DOCS_URL_FULL}/demos/#freepbx`,
    FreeSwitch: `${DOCS_URL_FULL}/demos/#freeswitch`,
    Asterisk: `${DOCS_URL_FULL}/demos/#asterisk`,
    Other: `${DOCS_URL_FULL}/demos/#auto-uploader`,
};
export const VoIpServerTypesTranslationKeys = {
    get '3CX'() { return i18n.t('3cx_'); },
    get FreePBX() { return i18n.t('freepbx_'); },
    get FreeSwitch() { return i18n.t('freeswitch_'); },
    get Asterisk() { return i18n.t('asterisk_'); },
    get Other() { return i18n.t('other_'); },
};
